import type { RouteRecordRaw } from 'vue-router'
import { MenuOrderPage } from '@myorg/menu-editor-lib'
import { api } from '../../services/api'
import { ROUTES, API_ENDPOINTS, logger, confirmDuplicateOrders } from '@myorg/type-lib'
import {MenuOrderApi,OrderHistoryApi, type PaymentPayload } from '@myorg/type-lib'
import axios from 'axios';
import i18n from '../../i18n'
import Swal from 'sweetalert2'
import { STORAGE_KEYS } from '@/config/storageKeys'

export const menuApiImpl: MenuOrderApi = {
  getMenuByQr: async (qr: string) => {
    if (qr == "" || qr == ":qr") return
    const res = await api().get(API_ENDPOINTS.MENU.GET_MENU_BY_QR(qr))
    const tz = res.data.tz || 'UTC'
    localStorage.setItem(STORAGE_KEYS.MERCHANT_TIMEZONE, tz)
    return res.data
  },
  submitOrder: async (payload: any) => {
    const res = await api().post(API_ENDPOINTS.MENU.ORDER_SUBMIT, payload)
    return res.data
  },
  // submitPayment: async (payload: any) => {
  //   const res = await api().post(API_ENDPOINTS.MENU.ORDER_SUBMIT, payload)
  //   return res.data
  // },
  handlePayment: async (payload: PaymentPayload) => {
    // 1. Validate QR Code
    if (!payload.qr || typeof payload.qr !== 'string' || payload.qr.trim() === '') {
      console.error("handlePayment Validation Error: QR code is missing or invalid");
      return false;
    }

    // 2. Validate Order IDs (ensure it's an array and not empty)
    if (!Array.isArray(payload.ids) || payload.ids.length === 0) {
      console.error("handlePayment Validation Error: No order IDs selected");
      return false;
    }

    try {
      const checkoutInfo = payload
      // 1. Check for duplicates before processing checkout
      const checkoutPayload = {
        qr: payload.qr,
        ids: payload.ids,
        merchant_id: payload.merchant_id,
        carrier_num: checkoutInfo.carrier_num,
        customer_identifier: checkoutInfo.customer_identifier,
        customer_name: checkoutInfo.customer_name,
        customer_email: checkoutInfo.customer_email,
      };

      logger.log("Checking for duplicate orders with payload:", checkoutPayload);

      const checkResponse = await api().post(API_ENDPOINTS.BFF.PAYMENT_CHECK_DUPLICATES, checkoutPayload);

      const checkDuplicates = checkResponse.data.duplicates;

      const isConfirmed = await confirmDuplicateOrders(checkDuplicates)
      if (!isConfirmed) {
        return false;
      }

      // 2. Get signed data using your Axios instance
      // This will now automatically include your Auth tokens via interceptors
      const now = new Date();
      const timestamp = now.getFullYear() +
        String(now.getMonth() + 1).padStart(2, '0') +
        String(now.getDate()).padStart(2, '0') +
        String(now.getHours()).padStart(2, '0') +
        String(now.getMinutes()).padStart(2, '0') +
        String(now.getSeconds()).padStart(2, '0');

      const response = await api().post(API_ENDPOINTS.BFF.PAYMENT_BATCH_CHECKOUT, checkoutPayload);


      // Axios puts the JSON body in 'data'
      const params = response.data;

      logger.log("Payment Payload:", {
        qr: payload.qr,
        ids: payload.ids,
        res: response,
        params: params
      });
      // 2. Create dynamic form
      const form = document.createElement('form');
      form.method = 'POST';
      const ECPAY_URL = import.meta.env.VITE_API_ECPAY_URL;

      form.action = ECPAY_URL;

      // 3. Add fields as hidden inputs
      Object.keys(params).forEach(key => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = params[key];
        form.appendChild(input);
      });

      // 4. Append to body and submit
      // document.body.appendChild(form);
      // form.submit();
      return form

    } catch (error) {
      if (axios.isAxiosError(error)) {
        // TypeScript now knows 'error' is an AxiosError
        const serverData = error.response?.data;
        const errorCode = serverData?.error_code;
        // console.error("serverData:", serverData);
        // console.error("errorCode:", errorCode);

        if (errorCode === "BFFErrSvcBatchProcessAmountLimit") {
          return "BFFErrSvcBatchProcessAmountLimit"
        }
      } else {
        // This handles non-Axios errors (like code crashes)
        logger.error("Native error:", error);
      }
      logger.error("Payment failed:", error);
      return error;
    } finally {
      // this.loading = false;
    }
  },
  // getImages: async () => {
  //     const res = await api().get('/api/booking/merchants/images')
  //     return res.data
  //   },
  getImages: async (id :string) => {
      const url = API_ENDPOINTS.BOOKING.PUBLIC_IMAGES.replace(':id', id)
      const res = await api().get(url)
      return res.data
    },
  queryCompanyName: async (ubn) => {
    const res = await api().get(API_ENDPOINTS.ECPAY.QUERY_COMPANY_NAME_PUBLIC(ubn))
    return res.data
  },
}

export const orderApiImpl : OrderHistoryApi= {
  getTableOrders: async (qr: string) => {
    const res = await api().get(API_ENDPOINTS.MENU.GET_ORDERS_BY_QR(qr))
    return res.data
  },
  getTableSessionOrders: async (qr: string) => {
    const res = await api().get(API_ENDPOINTS.MENU.GET_ORDERS_SESSION_BY_QR(qr))
    return res.data
  },

}


// 環境變數判斷
const baseUrl = import.meta.env.VITE_UPLOAD_R2_URL

export const menuOrderRoute: RouteRecordRaw = {
  path: ROUTES.MENU_ORDER.PATH,
  name: ROUTES.MENU_ORDER.NAME,
  component: MenuOrderPage,
  props: (route) => ({
    t: i18n.global.t,
    menuApi: menuApiImpl,
    orderApi: orderApiImpl,
    qr: route.params.qr as string,
    baseUrl:baseUrl,
  })
}
